module.exports = __webpack_public_path__ + "img/advantage3_1@2x.f7b6945c.png";